import { Attributes, DateUtils, Misc, Model, Rules, Validation } from '@singularsystems/neo-core';
import TemporalEntity from '../TemporalEntity';

export default class Note extends TemporalEntity {

    constructor() {
        super();
        this.makeObservable();
    }

    public noteId: number = 0;

    @Rules.StringLength(500)
    @Rules.Required()
    public noteDescription: string = "";

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public reminderDate: Date | null = null;

    public completed: Model.UserEvent = Model.UserEvent.None();

    @Rules.Required()
    public noteTypeId: number | null = null;

    @Attributes.Serialisation(Misc.SerialiseType.NotNull)
    @Attributes.Nullable()
    public issuerId: number | null = null;

    @Attributes.Serialisation(Misc.SerialiseType.NotNull)
    @Attributes.Nullable()
    public investorId: number | null = null;

    @Attributes.Nullable()
    public investorInvestmentId: number | null = null;

    @Attributes.Nullable()
    public issuerInvestmentId: number | null = null;

    // Client only properties / methods

    public get canComplete() {
        return this.completed.on == undefined && this.reminderDate !== null;
    }

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
        rules.failWhen(c => c.isNew && c.reminderDate != null && c.reminderDate < DateUtils.today(), "Reminder date cannot be set in the past");
    }

    public toString(): string {
        if (this.isNew || !this.noteDescription) {
            return "New note";
        } else {
            return this.noteDescription;
        }
    }
}